import { render, staticRenderFns } from "./TripPointsDetailsGrid.vue?vue&type=template&id=9af9cf08&"
import script from "./TripPointsDetailsGrid.vue?vue&type=script&lang=ts&"
export * from "./TripPointsDetailsGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports